/**
 * Largeur (px de base) sous laquelle le menu fichier n'est plus lisible : en
 * dessous, la légende et l'échelle se replient en un seul bouton.
 */
export const FILE_MENU_MIN_PX = 150;

/** Marge (px) avant de déplier de nouveau, pour ne pas osciller. */
export const LEGEND_COMPACT_HYSTERESIS_PX = 12;

export interface LegendCompactInput {
  /** Décision actuelle. */
  compact: boolean;
  /** Largeur actuelle du menu fichier. */
  fileWidth: number;
  /** Texte du nom du plan masqué par la troncature (0 s'il est entier). */
  fileOverflow: number;
  /** Place libre restante sur la 1re ligne de l'en-tête. */
  freeWidth: number;
  /**
   * Largeur que reprendraient les 2 boutons Légende + Échelle par rapport au
   * bouton unique (0 = pas encore connue).
   */
  expandDelta: number;
}

/**
 * Légende et échelle repliées en un seul bouton ? Toutes les largeurs dans la
 * même unité (px de mise en page). Le menu fichier a la priorité : on replie
 * dès que son nom est rogné sous FILE_MENU_MIN_PX, on déplie quand la place
 * libre (plus ce que le menu fichier peut céder sans passer sous ce seuil)
 * suffit à reloger les 2 boutons.
 */
export function shouldCompactLegend(
  input: LegendCompactInput,
  minFileWidth: number = FILE_MENU_MIN_PX,
  hysteresis: number = LEGEND_COMPACT_HYSTERESIS_PX,
): boolean {
  const { compact, fileWidth, fileOverflow, freeWidth, expandDelta } = input;
  // Pas encore mesuré (montage, en-tête masqué) : on ne touche à rien.
  if (fileWidth <= 0) return compact;
  // Un nom court n'a jamais besoin de toute la largeur minimale.
  const fileNeed = Math.min(fileWidth + fileOverflow, minFileWidth);
  if (!compact) return fileWidth + 0.5 < fileNeed;
  // Largeur dépliée inconnue : rester replié plutôt que deviner.
  if (expandDelta <= 0) return true;
  return freeWidth + (fileWidth - fileNeed) < expandDelta + hysteresis;
}
